import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import ClientComponents from '@components/ClientComponents';
import { getSectionRoute } from '@services/routes.service';
import ShelvesSections from './ShelvesSections';

const Container = styled.div`
  padding: ${({ theme }) => theme.spacing(0, 6, 0, 6)};
`;

export class ShelvesLayout extends React.PureComponent {
  static propTypes = {
    countryCode: PropTypes.string.isRequired,
    isFetchingMenu: PropTypes.bool.isRequired,
    hasToValidateAge: PropTypes.bool.isRequired,
    openAgeValidation: PropTypes.func.isRequired,
    menu: PropTypes.object,
    pushPage: PropTypes.func.isRequired,
    onBeforeProductConfig: PropTypes.func.isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        city: PropTypes.string,
        restaurant: PropTypes.string,
      }),
    }).isRequired,
    sectionsHeights: PropTypes.object.isRequired,
    onSectionHeightUpdated: PropTypes.func.isRequired,
    businessType: PropTypes.string,
    measurementItems: PropTypes.array,
    trackBeforePriceProductsLoaded: PropTypes.func,
    trackSectionDetailsLoaded: PropTypes.func,
    shopAcceptsPreOrder: PropTypes.bool,
    shopIsOpen: PropTypes.bool,
  };

  onShelveExpand = section => () => {
    const { pushPage, match } = this.props;
    const { city, restaurant } = match.params;
    const { trackSectionDetailsLoaded } = this.props;
    pushPage(getSectionRoute({ city, restaurant, sectionId: section.id }));
    trackSectionDetailsLoaded({
      sectionId: section.id,
      sectionType: section.customImage?.type,
    });
  };

  componentDidUpdate(prevProps) {
    const { menu } = this.props;
    const { menu: prevMenu } = prevProps;
    const { trackBeforePriceProductsLoaded } = this.props;
    if (prevMenu?.count !== menu?.count) {
      trackBeforePriceProductsLoaded();
    }
  }

  render() {
    const {
      menu,
      isFetchingMenu,
      countryCode,
      onBeforeProductConfig,
      openAgeValidation,
      hasToValidateAge,
      sectionsHeights,
      onSectionHeightUpdated,
      businessType,
      measurementItems,
      shopAcceptsPreOrder,
      shopIsOpen,
    } = this.props;

    if (isFetchingMenu && !menu) return null;
    return (
      <ClientComponents>
        <Container>
          <ShelvesSections
            menu={menu}
            countryCode={countryCode}
            onShelveExpand={this.onShelveExpand}
            onBeforeProductConfig={onBeforeProductConfig}
            openAgeValidation={openAgeValidation}
            hasToValidateAge={hasToValidateAge}
            onSectionHeightUpdated={onSectionHeightUpdated}
            sectionsHeights={sectionsHeights}
            businessType={businessType}
            measurementItems={measurementItems}
            shopAcceptsPreOrder={shopAcceptsPreOrder}
            shopIsOpen={shopIsOpen}
          />
        </Container>
      </ClientComponents>
    );
  }
}

export default injectIntl(withRouter(ShelvesLayout));
